'use client';
import { ConfigProvider } from 'antd';
import faIR from 'antd/locale/fa_IR';
import { ContextProviderComp, GlobalContext } from 'context';
import React, { useContext, useEffect } from 'react';
import { useCoarsePointer } from 'scripts';
import { AntdTheme } from 'utilities';
import { __AppKeeperPropsType } from './appKeeper.type';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const AppKeeperComp: React.FC<React.PropsWithChildren<__AppKeeperPropsType>> = (
    props: React.PropsWithChildren<__AppKeeperPropsType>,
) => {
    useEffect(() => {
        document.addEventListener('contextmenu', eventHandler);
        return () => {
            document.removeEventListener('contextmenu', eventHandler);
        };
    }, []);

    function eventHandler(event: MouseEvent) {
        if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
            event.preventDefault();
    }

    return (
        <QueryClientProvider client={queryClient}>
            <ContextProviderComp
                theme={props.theme}
                profile={props.profile}
                location={props.location}
                parentLocations={props.parentLocations}
                categories={props.categories}
                chatDeactivateMessage={props.chatDeactivateMessage}
            >
                <ThemeComp>{props.children}</ThemeComp>
            </ContextProviderComp>
        </QueryClientProvider>
    );
};

const ThemeComp: React.FC<React.PropsWithChildren> = (props) => {
    const { theme } = useContext(GlobalContext);
    const coarsePointer = useCoarsePointer();
    return (
        <ConfigProvider
            direction={'rtl'}
            locale={faIR}
            theme={AntdTheme(theme)}
            virtual={coarsePointer ? false : undefined}
        >
            {props.children}
        </ConfigProvider>
    );
};

export default AppKeeperComp;
